import { IRmaListTab } from "../../../services/api/rma-list-service";
import { MixpanelOptionalProperties } from "../../../services/mixpanel.service";
import rmsMixpanelStore from "../../../stores/rms-mixpanel-store";

export const MANAGE_RETURNS_DESIGN_VERSION = {
    V1: "v1",
    V2: "v2",
} as const;

export type ManageReturnsDesignVersion =
    (typeof MANAGE_RETURNS_DESIGN_VERSION)[keyof typeof MANAGE_RETURNS_DESIGN_VERSION];

const DESIGN_VERSION_PROPERTY = "Design version";

const TAB_EVENT_BY_STATUS_GROUP: Record<IRmaListTab, string> = {
    [IRmaListTab.STATUS_GROUP_OPEN]: "d&_tab_open",
    [IRmaListTab.STATUS_GROUP_CLOSED]: "d&_tab_closed",
    [IRmaListTab.STATUS_GROUP_ALL]: "d&_tab_all",
};

export function trackManageReturnsListEvent(
    eventName: string,
    designVersion: ManageReturnsDesignVersion,
    properties?: MixpanelOptionalProperties,
): void {
    rmsMixpanelStore.trackEvent(eventName, {
        [DESIGN_VERSION_PROPERTY]: designVersion,
        ...properties,
    });
}

export function trackManageReturnsDesignToggle(
    destinationVersion: ManageReturnsDesignVersion,
    previousVersion: ManageReturnsDesignVersion,
): void {
    rmsMixpanelStore.trackEvent("d&_manage_returns_design_toggle", {
        [DESIGN_VERSION_PROPERTY]: destinationVersion,
        previous_version: previousVersion,
    });
}

export function trackManageReturnsListTabEvent(tab: IRmaListTab): void {
    trackManageReturnsListEvent(
        TAB_EVENT_BY_STATUS_GROUP[tab],
        MANAGE_RETURNS_DESIGN_VERSION.V2,
    );
}
